var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.181,
    height: 38.182,
    viewBox: "0 0 38.181 38.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28342",
    "data-name": "Group 28342",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-join-svgrepo-com",
    transform: "translate(-5918.057 5662.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16000",
    "data-name": "Path 16000",
    d: "M5929.82-5638.462h-3a1,1,0,0,1-1-1,1,1,0,0,1,1-1h3a5.314,5.314,0,0,0,3.731-1.545l1.345-1.346a7.326,7.326,0,0,1,1.375-1.08,6.01,6.01,0,0,1-1.008-.815l-2.077-2.077a4,4,0,0,0-2.843-1.178h-3.525a1,1,0,0,1-1-1,1,1,0,0,1,1-1h3.525a5.982,5.982,0,0,1,4.257,1.764l2.078,2.078a3.993,3.993,0,0,0,2.843,1.179h5.541l-2.059-2.059a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0l3.764,3.764.015.015v0a.971.971,0,0,1,.2.31,1.018,1.018,0,0,1,.076.363v.037a1.023,1.023,0,0,1-.076.363,1,1,0,0,1-.217.326l-3.766,3.765a1,1,0,0,1-1.414,0,1,1,0,0,1,0-1.414l2.059-2.058h-5.024a5.307,5.307,0,0,0-3.727,1.544l-1.346,1.345A7.23,7.23,0,0,1,5929.82-5638.462Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDarkIcon);
export default __webpack_public_path__ + "static/media/arrowDark-icon.6681fb2c3b6bf123aefcc87a10d0644c.svg";
export { ForwardRef as ReactComponent };